import { Trans } from "@lingui/react/macro";
import React, { useEffect } from "react";
import {
  SectionContainer,
  OpeningText,
  OpeningTextHeading,
  OpeningTextSubHeading
} from "@silversea-ssc/ui-components-react";
import { graphql, PageProps } from "gatsby";
import { Page404Query } from "types/graphql-types";
import SanityBuilderToComponents, { hasContent } from "components/PageBuilder";
import FindYourCruiseSearchBox from "components/FindYourCruiseSearchBox/FindYourCruiseSearchBox";

const NotFoundPage: React.FC<
  React.PropsWithChildren<PageProps<Page404Query>>
> = ({ data }) => {
  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ is404: true });
  }, []);
  const { offersSection, destinationsSection } = data;
  return (
    <div>
      <SectionContainer
        spacingTop="regular"
        spacingBottom="regular"
        backgroundColor="white"
      >
        <OpeningText>
          <OpeningTextHeading>
            <Trans>Page not found</Trans>
          </OpeningTextHeading>
          <OpeningTextSubHeading>
            <Trans>Page not found text</Trans>
          </OpeningTextSubHeading>
        </OpeningText>
      </SectionContainer>
      <FindYourCruiseSearchBox
        backgroundColor="neutral01"
        fycPageUrl={data.fycPagePath}
        firstLastDepartureCruiseDates={data.firstLastDepartureCruiseDates}
        enableSticky={false}
        lowTranslateY={true}
      />
      {offersSection && hasContent(offersSection?.sections) && (
        <SanityBuilderToComponents
          sections={offersSection.sections}
          initialBackgroundColor="neutral05"
        />
      )}
      {destinationsSection && hasContent(destinationsSection?.sections) && (
        <SanityBuilderToComponents
          sections={destinationsSection.sections}
          initialBackgroundColor="white"
        />
      )}
    </div>
  );
};

export const query = graphql`
  query Page404 {
    fycPagePath

    firstLastDepartureCruiseDates: firstLastDepartureCruiseDates {
      minYearMonth
      maxYearMonth
    }

    offersSection: sanitySharedSection(
      slug: { current: { eq: "exclusive-offers-slider" } }
    ) {
      sections {
        ...PageBuilderSections
      }
    }
    destinationsSection: sanitySharedSection(
      slug: { current: { eq: "destinations-slider" } }
    ) {
      sections {
        ...PageBuilderSections
      }
    }
  }
`;

export default NotFoundPage;
